<app-new-modal-body>
    <div class="tw:p-2 tw:text-center">
        <h6 class="tw:h6 tw:mb-6 tw:w-full tw:text-center tw:text-warning-500">{{ 'REPLACE_INVOICE_MODAL.title' | translate }}</h6>
        <div class="tw:mb-6 tw:w-full tw:text-center">{{ 'REPLACE_INVOICE_MODAL.description' | translate }}</div>

        @if (isInvoicingActive() && [InvoiceStatus.INVOICED, InvoiceStatus.PARTIALLY_INVOICED].includes(existingSalePreview()?.invoiceStatus)) {
            <div class="tw:mb-6 tw:w-full tw:text-center">{{ 'REPLACE_INVOICE_MODAL.descriptionInvoice' | translate }}</div>

            <div class="tw:flex tw:mb-4 tw:text-left tw:items-center tw:justify-start tw:gap-4 tw:py-2 tw:px-4 tw:text-sm tw:bg-primary-100 tw:rounded-lg">
                <app-icon icon="info" class="tw:text-primary-400" />
                <div>
                    {{ 'REPLACE_INVOICE_MODAL.warningMessage' | translate }}
                </div>
            </div>
        } @else {
            <div class="tw:mb-6 tw:w-full tw:text-center">{{ 'REPLACE_INVOICE_MODAL.descriptionNoInvoice' | translate }}</div>
        }

        <div class="tw:flex tw:gap-4">
            <app-button [disabled]="saving()" type="secondary" (clickEvent)="close()">{{ 'REPLACE_INVOICE_MODAL.back' | translate }} </app-button>
            <app-button [loading]="saving()" type="primary" (clickEvent)="continue()">
                {{ 'REPLACE_INVOICE_MODAL.cancelSale' | translate }}
            </app-button>
        </div>
    </div>
</app-new-modal-body>
